export default __webpack_public_path__ + "3_provide_mobile.png";